<wbo-single-select-control [valueField]="valueField"
                           [labelField]="labelField"
                           [placeholder]="placeholder"
                           [(value)]="value"
                           [sourceSearchModel]="model"
                           [data]="data"
                           (onDataLoaded)="onDataLoaded($event)"
                           [removable]="removable"
                           [objectValue]="objectValue"
                           [labelSearchField]="labelSearchField"
                           [label]="label"
                           (onSelect)="onSelect.emit($event)"
                           (removed)="onRemove()"
                           [attr.id]="elementId"
                           [initialDefaultValue]="initialDefaultValue"
                           [notifyInitialDefault]="notifyInitialDefault"
                           [allowClearSelectionOption]="allowClearSelectionOption"
                           [clearSelectionOptionLabel]="clearSelectionOptionLabel"
                           [extendedSearchComponent]="extendedSearchComponent"
                           [extendedEditComponent]="extendedEditComponent">
</wbo-single-select-control>
